.container {
    height: calc(100vh - 118px);
    background-color: var(--skeleton-grey);
    min-width: 808px;
    overflow-y: hidden;
    overflow-x: auto;
}

.content-container {
    height: calc(100%);
    padding: 12px;
    box-sizing: border-box;
}

.sidebar-container {
    min-width: 400px;
    width: 400px;
    display: flex;
    background-color: white;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 16px;
    overflow-y: auto;
    height: 100%;
}

.workspace-container {
    min-width: 780px;
    width: 100%;
    display: flex;
    background-color: white;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 16px;
    overflow-y: auto;
    height: 100%;
    gap: 16px;
}

.workspace-cue-card-container {
    min-width: 230px;
}
